import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CoreMenuService } from '@core/components/core-menu/core-menu.service';
import { Router, RoutesRecognized } from '@angular/router';
import { CoreMenu } from '@core/types';

@Component({
  selector: '[core-menu]',
  templateUrl: './core-menu.component.html',
  styleUrls: ['./core-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoreMenuComponent implements OnInit {
  currentUser: any;

  @Input()
    layout = 'vertical';

  @Input()
    menu: any;

  // Private
  private _unsubscribeAll: Subject<any>;
  public subdomain = 'default';

  /**
   *
   * @param _changeDetectorRef
   * @param _coreMenuService
   * @param router
   */
  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _coreMenuService: CoreMenuService,
    private router: Router
  ) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
    if (localStorage.getItem('currentUserSubdomainMybenefits')) {
      this.subdomain = localStorage.getItem('currentUserSubdomainMybenefits');
    }
  }

  // Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Set the menu either from the input or from the service

    this.router.events.subscribe((val) => {
      if (val instanceof RoutesRecognized) {
        if (val.state.root.firstChild.params['subdomain']) {
          this.subdomain = val.state.root.firstChild.params['subdomain'];
        }
      }
    });
    if (this.menu) {
      this.menu = this.menu.map((item: CoreMenu) => {
        item.subdomain = this.subdomain;
        return item;
      });
    }

    // Subscribe to the current menu changes
    this._coreMenuService.onMenuChanged
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(() => {
        this.currentUser = this._coreMenuService.currentUser;
        // Load menu
        if (this.currentUser) {
          this.setMenu();
        } else {
          // this.router.navigate(['/authentication/login']);
        }

        this._changeDetectorRef.markForCheck();
      });
  }

  setMenu() {
    this.menu =
      this._coreMenuService
        .getCurrentMenu()
        .map((item: CoreMenu) => {
          item.subdomain = this.subdomain;
          return item;
        })
        .filter((item) => item.role
          ? item.role.filter((role) => this.currentUser.roles.indexOf(role) !== -1).length !== 0
          : true);
  }
}
